if (!customElements.get('eclat-collection-tabs')) {
  customElements.define(
    'eclat-collection-tabs',
    class EclatCollectionTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.viewAll = this.querySelector('[data-view-all]');

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index));
        });

        this.panels.forEach((panel) => this.setupCarousel(panel));

        // Theme editor: show the tab whose block is selected in the sidebar
        this.onBlockSelect = (event) => {
          const index = this.tabs.findIndex((tab) => tab.contains(event.target));
          if (index > -1) this.select(index);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.onResize = () => this.panels.forEach((panel) => this.updateArrows(panel));
        window.addEventListener('resize', this.onResize);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        window.removeEventListener('resize', this.onResize);
      }

      select(index, focus = false) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
        });
        this.panels.forEach((panel, i) => {
          panel.hidden = i !== index;
        });

        const panel = this.panels[index];
        if (!panel) return;
        if (this.viewAll && panel.dataset.viewAllUrl) this.viewAll.href = panel.dataset.viewAllUrl;
        this.updateArrows(panel);
      }

      onTabKeydown(event, index) {
        const last = this.tabs.length - 1;
        let next = null;
        if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
        if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = last;
        if (next === null) return;
        event.preventDefault();
        this.select(next, true);
      }

      setupCarousel(panel) {
        const track = panel.querySelector('.eclat-ct__track');
        if (!track) return;
        panel.querySelectorAll('.eclat-ct__arrow').forEach((arrow) => {
          arrow.addEventListener('click', () => {
            const item = track.querySelector('.eclat-ct__item');
            const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
            const step = item ? item.offsetWidth + gap : track.clientWidth;
            // Move by one full "page" of visible cards
            const perPage = Math.max(1, Math.round((track.clientWidth + gap) / step));
            track.scrollBy({ left: Number(arrow.dataset.dir) * step * perPage, behavior: 'smooth' });
          });
        });
        track.addEventListener('scroll', () => this.updateArrows(panel), { passive: true });
        this.updateArrows(panel);
      }

      updateArrows(panel) {
        if (panel.hidden) return;
        const track = panel.querySelector('.eclat-ct__track');
        const media = panel.querySelector('.eclat-ct__media');
        if (!track) return;

        // Centre arrows on the product images, not the whole card
        if (media) panel.style.setProperty('--ect-arrow-top', `${media.offsetHeight / 2}px`);

        const max = track.scrollWidth - track.clientWidth;
        const prev = panel.querySelector('.eclat-ct__arrow--prev');
        const next = panel.querySelector('.eclat-ct__arrow--next');
        if (prev) prev.hidden = track.scrollLeft <= 1;
        if (next) next.hidden = track.scrollLeft >= max - 1;
      }
    }
  );
}
